import { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import ProtectedRoute from "./Routes/ProtectedRoute";
import Greetings from "./components/Greetings/Greetings";
import Wrapper from "./pages/Wrapper";
import AppRoutes from "./Routes/AppRoutes";
import { AppContext } from "./Context/Context";
import BackendConnectivity from "./components/BackendConnectivity/BackendConnectivity";
import MapModal from "./components/Modal/MapModal/MapModal";
import Heatmap from "./components/HeatMap/Heatmap";
import BlockRackModal from "./components/Modal/BlockRackModal/BlockRackModal";
import LineProductionShowModal from "./components/Modal/LineProductionShowModal/LineProductionShowModal";
import DockDoorModal from "./components/Modal/DockDoorModal/DockDoorModal";
import LgvPopup from "./components/Modal/LgvPopup/LgvPopup";
import PlantGuard from "./Routes/PlantGuard";
import { useDispatch, useSelector } from "react-redux";
import { setIsHeatmapModeEnabled } from "./store/heatmapSlice";

const App = () => {
  useMsalAuthentication(InteractionType.Redirect);
  const {
    siteSelectionModal,
    connectionStatus,
    isBlockRackModalOpen,
    selectedMarkerData,
    selectedMarkerType,
    isMarkerPopupOpen,
    socketConnection
  } = useContext(AppContext);
  const dispatch = useDispatch();
  const { selectedBlockRackLocationData } = useSelector((state) => state.plant);
  const { isHeatmapModeEnabled } = useSelector((state) => state.heatmap);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Greetings />
            {siteSelectionModal && <MapModal />}
          </>
        }
      />
      <Route
        path=":plantCode/*"
        element={
          <ProtectedRoute>
            <Wrapper>
              <PlantGuard>
                <AppRoutes />
              </PlantGuard>
              <BackendConnectivity status={connectionStatus} />
              {/* App level modal */}
              {isHeatmapModeEnabled ? (
                <Heatmap
                  closeModal={() => dispatch(setIsHeatmapModeEnabled(false))}
                />
              ) : null}
              {isBlockRackModalOpen &&
              Object.values(selectedBlockRackLocationData).length !== 0 ? (
                <BlockRackModal />
              ) : null}
              {selectedMarkerData &&
              selectedMarkerType === "productionLine" &&
              isMarkerPopupOpen ? (
                <LineProductionShowModal lineData={selectedMarkerData} />
              ) : null}
              {socketConnection &&
              selectedMarkerData &&
              selectedMarkerType === "dock" &&
              isMarkerPopupOpen ? (
                <DockDoorModal dockData={selectedMarkerData} />
              ) : null}
              {selectedMarkerData &&
              selectedMarkerType === "lgv" &&
              isMarkerPopupOpen ? (
                <LgvPopup lgv={selectedMarkerData} />
              ) : null}
            </Wrapper>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default App;
